/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Components.Controls {
  "use strict";

  export class SmartTilePropImageUrl implements angular.IComponentOptions {
    templateUrl = "app/components/controls/smartCenterDesigner/propertyViews/smartTilePropImageUrl.component.html";
    bindings: any = {
        prop: '=?',
        tileColumnSpan: '<',
        tileRowSpan: '<'
    }

    controller = class SmartTilePropImageUrlController {
      public prop: Meevo.Model.SmartTileParameter;
      //public aspectRatio: number;
      storedAspectRatio: number;
      tileColumnSpan: number;
      tileRowSpan: number;
      
      constructor() {
          if (!this.prop.parameterValue) {
            this.prop.parameterValue = {
                          meevoFile: {},
                          fileGuid: '',
                          isStorageUpdated: false
                      }
          }
          

      }

      public getImageUrl(istoreObj, defaultUri) {
          let forp = Model.StorageFileHelper.imageUri(istoreObj, defaultUri);
          return forp;
      }
      
      public isTileInvalidSize() {
          let aspectRatio = this.tileColumnSpan / this.tileRowSpan;
          switch (aspectRatio) {
              case 1:
                  return false;

              case 2:
                  return false;

              case .5:
                  return false;

              case 3:
              case 4:
                  return false;

              case (1 / 3):
                  return false;
              case (3 / 2):
                  return false;

              default:
                  return true;
          }
      }

      public getFileType() {
          let aspectRatio = this.tileColumnSpan / this.tileRowSpan;
          this.prop.parameterValue;
          switch (aspectRatio) {
              case 1:
                  this.storedAspectRatio = aspectRatio;
                  return Meevo.Model.FileTypes.SmartTileImage11;

              case 2:
                  this.storedAspectRatio = aspectRatio;
                  return Meevo.Model.FileTypes.SmartTileImage21;

              case .5:
                  this.storedAspectRatio = aspectRatio;
                  return Meevo.Model.FileTypes.SmartTileImage12;
              case 3:
                  this.storedAspectRatio = aspectRatio;
                  return Meevo.Model.FileTypes.SmartTileImage41;
              case 4:
                  this.storedAspectRatio = aspectRatio;
                  return Meevo.Model.FileTypes.SmartTileImage41;

              case (1 / 3):
                  this.storedAspectRatio = aspectRatio;
                  return Meevo.Model.FileTypes.SmartTileImage13;

          }

      }
    }
  }

  angular.module("meevo.components.controls")
    .component("stpImageUrl", new SmartTilePropImageUrl());
}
